import { cloneDeep } from "lodash"
const setTollFreeRequests = function (state, data: any) {
  const {sid, tollFreeRequest} = data
  const clone = cloneDeep(state.tollFreeRequests)
  clone[sid] = tollFreeRequest

  state.tollFreeRequests = clone
}

export default setTollFreeRequests

